import { render, staticRenderFns } from "./SidePanelBannerCopyValue.vue?vue&type=template&id=383d38ba&scoped=true"
import script from "./SidePanelBannerCopyValue.vue?vue&type=script&lang=js"
export * from "./SidePanelBannerCopyValue.vue?vue&type=script&lang=js"
import style0 from "./SidePanelBannerCopyValue.vue?vue&type=style&index=0&id=383d38ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d38ba",
  null
  
)

export default component.exports